"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_router_1 = require("vue-router");
const qs_1 = __importDefault(require("qs"));
const security_1 = __importDefault(require("./paths/security"));
const admin_1 = __importDefault(require("./paths/admin"));
const frontend_1 = __importDefault(require("./paths/frontend"));
//import Dashboard from "../pages/dashboard/Dashboard.vue";
const Home_vue_1 = __importDefault(require("../pages/backend/home/Home.vue"));
exports.default = (0, vue_router_1.createRouter)({
    history: (0, vue_router_1.createWebHistory)(),
    routes: [
        ...frontend_1.default,
        ...security_1.default,
        ...admin_1.default,
        {
            name: "dashboard",
            path: "/admin",
            component: Home_vue_1.default,
            meta: { requiresAuth: true, title: "Dashboard" },
        },
    ],
    // @ts-ignore
    parseQuery: qs_1.default.parse,
    stringifyQuery: (query) => {
        return qs_1.default.stringify(query, { encodeValuesOnly: true });
    },
});
